export enum ShopItemType {
  ADOPTABLES = 'adoptables',
  COMMISSIONS = 'commissions',
  ORIGINALS = 'originals',
  PREMIUM_CONTENT = 'premium_content',
  PREMIUM_FOLDERS = 'premium_folders',
}
